<template>
	<div>
		<h3>{{$t('addresses.Address')}}</h3>
		<el-card :body-style="{ padding: '0px' }" shadow="always">
			<div class="card-info">
				<el-row :gutter="20">
					<el-col :span="21" class="company-fiche-info">
					 	<el-row :gutter="20">
					 		<el-col>
					 			<span class="company-name company-info">{{company.name}}</span>
								<span v-if="company.usual_name!=null && company.usual_name!=''" class="company-name company-info" style="font-size:1em;">({{company.usual_name}})</span>
					 		</el-col>
					 	</el-row>
					 	<el-row :gutter="20" v-if="company.email">
					 		<el-col>
					 			<i class="mdi mdi-email-outline"></i><span class="company-info">{{company.email}}</span>
					 		</el-col>
					 	</el-row>
					 	<el-row :gutter="20" v-if="company.phone">
					 		<el-col>
					 			<i class="mdi mdi-phone"></i><span class="company-info">{{company.phone}}</span>
					 		</el-col>
					 	</el-row>
					 	<el-row>
					 		<el-col :span="1">
					 			<i class="mdi mdi-map-marker-outline"></i>
					 		</el-col>
					 		<el-col :span="23" style="padding-left:2px;">
					 			<div>
					 				<div v-if="getAddressLine1!=null"><span class="company-info">{{getAddressLine1}}</span><br></div>
					 				<div v-if="getAddressLine2!=null"><span class="company-info">{{getAddressLine2}}</span><br></div>
					 				<div v-if="getAddressLine3!=null"><span class="company-info">{{getAddressLine3}}</span></div>
					 			</div>
					 		</el-col>
					 	</el-row>

					 </el-col>
				</el-row>
			</div>
		</el-card>
	</div>
</template>
<script>
export default {
	name: 'CompanyInfo',

	computed : {
		getAddressLine1(){
			if(this.company.street==null || this.company.street==''){
				return null
			}
			return this.company.street;
		},
		getAddressLine2(){
			var line = "";
			if(this.company.city!=null){
				line+=this.company.city;
			}
			if(this.company.postal_code!=null && this.company.postal_code!=''){
				if(line!=''){
					line+=", " + this.company.postal_code;
				}else{ line = this.company.postal_code}
			}
			if(line==""){return null}
			return line;

		},
		getAddressLine3(){
			var line="";
			if(this.company.state_name!=null){
				line+=this.company.state_name;
			}else if(this.company.other_state!=null && this.company.other_state!=""){
				line+=this.company.other_state;
			}
			if(line==""){line=this.company.country_name}else{line+=", "+this.company.country_name}
			return line;
		}
	},
	components : {
	},
	props: {
		company : Object
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.small{
	font-size:10pt;
	height:100px;
}
.hide{
	display:none;
}
.company-fiche-info{
	padding-left:10px!important;
}

.company-name{
  	font-size:1.6em;
  	color:#4a596a;
}

.company-info{
 	margin:5px;
 }


.card-info{
	margin:20px;
	color:#a9aaad;
}
.el-row{
	margin-bottom:5px;
}

</style>
